import React from 'react'
import { RevisionUnavailableFragment } from 'gqlTypes'
import VersionItem from 'components/VersionItem/VersionItem'

export interface ActivityRevisionUnavailableProps {
  revision: RevisionUnavailableFragment
}

export const ActivityRevisionUnavailable = ({
  revision,
}: ActivityRevisionUnavailableProps) => {
  const { createdAtNN: createdAt, creatorNN: creator, userIsCreator } = revision

  return (
    <VersionItem
      type="unavailable"
      creator={creator.name!}
      date={new Date(createdAt)}
      userIsCreator={userIsCreator}
      tooltip="Updates created before July 23, 2019 are not available"
      kind={'DRAFT'}
    />
  )
}
